import React, {useContext} from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import RowPhoto from "../../common/TdImg";

import { Link } from "react-router-dom";
import {YearContext} from "../../../contexts/yearContext";

const DataTable = ({ data, query }) => {
  const { entryYear } = useContext(YearContext);

  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/students/${e.student_id}/profile/fees?stdName=${e.student_name}`}
      >
        {e.student_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_photo",
      label: "عکس",
      content: ({ student_photo }) => <RowPhoto src={student_photo} />,
    },
    { path: "aria_id", label: "کد دانشجو" },
    {
      path: "student_name",
      label: "اسم",
      content: (e) => renderLink(e),
    },
    { path: "student_father_name", label: "ولد" },
    { path: "student_phone", label: "شماره تماس" },
    { path: "faculty_name", label: "پوهنحی" },
    { path: "department_name", label: "دیپارتمنت" },
    { path: "class_desc", label: "صنف" },
    { path: "entry_year", label: "سال ورود" },
    {
      path: "option",
      content: (e) => <Option EditStudentClass={e} DeleteStudentClass={e}  entryYear={entryYear} />,
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default DataTable;
